import * as yup from 'yup'
import { useSelector } from 'react-redux'

export const validationSchema = () => {
    const { locale } = useSelector(state => state.main)

    const addressSchema = yup.object().shape({
        company: yup
            .string()
            .required(locale.addressForm.companyNameRequireValidationMessage)
            .min(2, locale.addressForm.companyNameMinLengthValidationMessage)
            .max(50, locale.addressForm.companyNameMaxLengthValidationMessage)
            .matches(
                /^[\p{L}\d\s]+$/u,
                locale.addressForm.companyIsValidValidationMessage
            ),
        firstName: yup
            .string()
            .required(locale.addressForm.nameRequireValidationMessage)
            .min(2, locale.addressForm.nameMinLengthValidationMessage)
            .max(50, locale.addressForm.nameMaxLengthValidationMessage)
            .matches(
                /^[\Dа-я]+$/gi,
                locale.addressForm.nameIsValidValidationMessage
            ),
        lastName: yup
            .string()
            .required(locale.addressForm.lastNameRequireValidationMessage)
            .min(2, locale.addressForm.lastNameMinLengthValidationMessage)
            .max(50, locale.addressForm.lastNameMaxLengthValidationMessage)
            .matches(
                /^[\Dа-я]+$/gi,
                locale.addressForm.lastNameIsValidValidationMessage
            ),
        streetAndNumber: yup
            .string()
            .required(locale.addressForm.addressRequireValidationMessage)

            .test(
                locale.addressForm.addressInputLabel,
                locale.addressForm.addressIsValidValidationMessage,
                value => /^[\p{L}\d\s/\-'.,а-яА-Я]+$/u.test(value)
            ),

        zipCode: yup
            .string()
            .required(locale.addressForm.zipCodeRequireValidationMessage),
        /* .matches(
                /^\d{5}(?:[-\s]\d{4})?$/,
                locale.addressForm.zipCodeIsValidValidationMessage
            ) */ city: yup
            .string()
            .required(locale.addressForm.cityRequireValidationMessage)
            .matches(
                /^[\Dа-я]+$/gi,
                locale.addressForm.cityIsValidValidationMessage
            ),
        country: yup
            .string()
            .required(locale.addressForm.countryRequireValidationMessage)
            .matches(
                /^[\Dа-я]+$/gi,
                locale.addressForm.countryIsValidValidationMessage
            )
    })

    return { addressSchema }
}
